// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yH3Y","importantInfo":"styles_importantInfo__3nJDe"};